// PWA service worker registration helper. CRA-friendly.

export function registerSW() {
    if (
        typeof window === "undefined" ||
        !("serviceWorker" in navigator) ||
        process.env.NODE_ENV === "test"
    ) {
        return;
    }

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .then((reg) => {
                // Auto-refresh when a new SW takes over
                if (reg && reg.update) {
                    reg.update().catch(() => {});
                }
            })
            .catch((err) => {
                // Non-fatal: service worker is progressive enhancement
                console.warn("[sw] registration failed", err);
            });
    });
}
